<div class="mx-auto p-4">
  <div class="flex mb-4 bg-primary-200">
    <p-button text class="p-0 mx-4 border-0 shadow-none bg-transparent text-primary-900" (click)="pageMenu('Home')">
      <ng-template pTemplate="icon">
        <i class="pi pi-home !text-[30px]"></i>
      </ng-template>
    </p-button>
    <h2 class="text-2xl font-semibold text-primary">NotesApp Synchronisation Details</h2>
    <p-button icon="pi pi-refresh" (click)="reload()" label="Refresh" [ngStyle]="{ 'margin-left': '20px' }"></p-button>
  </div>

  <ng-container *ngIf="loading">
    <div class="text-4xl text-gray-500 mb-2">Loading records…</div>
  </ng-container>
  <ng-container *ngIf="!loading && !error">
    <div class="text-4xl text-gray-500 mb-2">
      Loaded {{ filteredSyncList.length }} record{{ filteredSyncList.length === 1 ? '' : 's' }}
    </div>
  </ng-container>
  <ng-container *ngIf="error">
    <div class="text-sm text-red-600 mb-2">{{ error }}</div>
  </ng-container>

  <div class="mb-4 flex flex-wrap gap-4 items-center">
    <label>
      Out-of-Sync:
      <select
        [(ngModel)]="filterOutOfSyncFlag"
        (ngModelChange)="applyFiltersAndSort()"
        class="border rounded px-2 py-1">
        <option value="">Any</option>
        <option value="true">True</option>
        <option value="false">False</option>
      </select>
    </label>
    <label>
      SyncStatus:
      <select [(ngModel)]="filterSyncStatus" (ngModelChange)="applyFiltersAndSort()" class="border rounded px-2 py-1">
        <option value="">Any</option>
        <option *ngFor="let status of syncStatusOptions" [value]="status">{{ status }}</option>
      </select>
    </label>
    <label>
      Status:
      <select [(ngModel)]="filterStatus" (ngModelChange)="applyFiltersAndSort()" class="border rounded px-2 py-1">
        <option value="">Any</option>
        <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
      </select>
    </label>
    <label>
      Sort by:
      <select [(ngModel)]="sortField" (ngModelChange)="applyFiltersAndSort()" class="border rounded px-2 py-1">
        <option value="SyncStatus">SyncStatus</option>
        <option value="_id">_id</option>
        <option value="SyncTime">SyncTime</option>
        <option value="ModifiedDate">ModifiedDate</option>
      </select>
    </label>
    <label>
      Direction:
      <select [(ngModel)]="sortDirection" (ngModelChange)="applyFiltersAndSort()" class="border rounded px-2 py-1">
        <option value="asc">Ascending</option>
        <option value="desc">Descending</option>
      </select>
    </label>
  </div>

  <div class="overflow-x-auto">
    <div *ngIf="loading" class="flex items-center justify-center py-16">
      <p-progressSpinner styleClass="w-12 h-12" strokeWidth="3" ariaLabel="Loading records"></p-progressSpinner>
    </div>
    <p-table
      *ngIf="!loading"
      [value]="filteredSyncList"
      [resizableColumns]="true"
      columnResizeMode="expand"
      styleClass="p-datatable-sm p-datatable-gridlines text-sm"
      tableStyleClass="min-w-full border border-gray-300"
      [tableStyle]="{ 'border-collapse': 'collapse', border: '1px solid #d1d5db' }">
      <ng-template pTemplate="header">
        <tr>
          <th
            pResizableColumn
            class="text-left p-2 border border-gray-300 whitespace-nowrap bg-gray-100 sticky top-0 z-10"
            style="width: 150px; max-width: 150px">
            ID
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">In-Sync?</th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">View</th>
          <th
            pResizableColumn
            class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10"
            style="width: 150px; max-width: 150px; word-break: break-all">
            Couch rec
          </th>
          <th
            pResizableColumn
            class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10"
            style="width: 150px; max-width: 150px; word-break: break-all">
            Local rec
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">
            syncStatus
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">
            Push Retry
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">syncTime</th>
          <th
            pResizableColumn
            class="text-left p-2 border border-gray-300 whitespace-nowrap bg-gray-100 sticky top-0 z-10"
            style="width: 150px; max-width: 150px">
            c-rev
          </th>
          <th
            pResizableColumn
            class="text-left p-2 border border-gray-300 whitespace-nowrap bg-gray-100 sticky top-0 z-10"
            style="width: 150px; max-width: 150px">
            l-rev
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">c-Created</th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">l-Created</th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">
            c-Modified
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">
            l-Modified
          </th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">Title</th>
          <th pResizableColumn class="text-left p-2 border border-gray-300 bg-gray-100 sticky top-0 z-10">Type</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rec>
        <tr class="odd:bg-white even:bg-gray-50">
          <td class="p-2 align-top font-mono border border-gray-300" style="width: 150px; max-width: 150px">
            <div class="flex items-center gap-2">
              <span class="whitespace-nowrap overflow-hidden text-ellipsis" [title]="rec._id">{{ rec._id }}</span>
              <p-button
                text
                icon="pi pi-copy"
                class="p-0 border-0 shadow-none"
                title="Copy ID"
                (click)="copyToClipboard(rec._id)"></p-button>
            </div>
          </td>
          <td class="p-2 align-top font-mono border border-gray-300 text-center">
            <ng-container *ngIf="rec.outOfSyncFlag === true">
              <span title="Out of Sync" style="color: red; font-size: 2.4em">&#10007;</span>
            </ng-container>
            <ng-container *ngIf="rec.outOfSyncFlag === false">
              <span title="In Sync" style="color: green; font-size: 2.4em">&#10003;</span>
            </ng-container>
          </td>
          <td class="p-0 align-top font-mono border border-gray-300">
            <p-button
              icon="pi pi-eye"
              class="p-button-sm"
              (click)="viewConflict(rec._id)"
              title="View record"></p-button>
          </td>
          <td
            class="p-0 font-mono border border-gray-300 align-middle"
            style="width: 150px; max-width: 150px; word-break: break-all; white-space: pre-wrap">
            {{ !rec.c_missing }}
            @if (!rec.c_missing) {
            <p-button
              size="small"
              severity="danger"
              styleClass="p-0 color-red-500"
              title="Delete CouchdB record"
              (onClick)="deleteRecord('couchDB', rec._id)">
              <span class="material-symbols-outlined text-base">close_small</span>
            </p-button>
            }
          </td>
          <td
            class="p-0 font-mono border border-gray-300 align-middle"
            style="width: 150px; max-width: 150px; word-break: break-all; white-space: pre-wrap">
            {{ !rec.l_missing }}
            @if (!rec.l_missing) {
            <p-button
              size="small"
              severity="danger"
              styleClass="p-0 color-red-500"
              title="Delete Local record"
              (onClick)="deleteRecord('local', rec._id)">
              <span class="material-symbols-outlined text-base">close_small</span>
            </p-button>
            }
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">{{ rec.syncStatus }}</td>
          <td class="p-2 align-top font-mono border border-gray-300" [title]="rec.pushFailure?.lastErrorMessage || ''">
            {{ formatPushRetry(rec) }}
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">
            {{ rec.syncTime | date : 'yyyy-MM-dd HH:mm:ss' }}
          </td>
          <td class="p-2 align-top font-mono border border-gray-300" style="width: 150px; max-width: 150px">
            <div class="flex items-center gap-2">
              <span class="whitespace-nowrap overflow-hidden text-ellipsis" [title]="rec.c_rev || ''">
                {{ rec.c_rev || '—' }}
              </span>
              <p-button
                text
                icon="pi pi-copy"
                class="p-0 border-0 shadow-none"
                title="Copy c-rev"
                [disabled]="!rec.c_rev"
                (click)="copyToClipboard(rec.c_rev)"></p-button>
            </div>
          </td>
          <td class="p-2 align-top font-mono border border-gray-300" style="width: 150px; max-width: 150px">
            <div class="flex items-center gap-2">
              <span class="whitespace-nowrap overflow-hidden text-ellipsis" [title]="rec.l_rev || ''">
                {{ rec.l_rev || '—' }}
              </span>
              <p-button
                text
                icon="pi pi-copy"
                class="p-0 border-0 shadow-none"
                title="Copy l-rev"
                [disabled]="!rec.l_rev"
                (click)="copyToClipboard(rec.l_rev)"></p-button>
            </div>
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">
            {{
              rec.c_created_on
                | date
                  : 'dd.MM.yyyy
                        HH:mm:ss'
            }}
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">
            {{
              rec.l_created_on
                | date
                  : 'dd.MM.yyyy
                        HH:mm:ss'
            }}
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">
            {{
              rec.c_last_modified
                | date
                  : 'dd.MM.yyyy
                        HH:mm:ss'
            }}
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">
            {{
              rec.l_last_modified
                | date
                  : 'dd.MM.yyyy
                        HH:mm:ss'
            }}
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">
            <ng-container *ngIf="!rec.Title || rec.Title.trim() === ''">
              <span title="No Title" style="color: red; font-size: 2em">&#10007;</span>
            </ng-container>
            <ng-container *ngIf="rec.Title && rec.Title.trim() !== ''">
              {{ rec.Title }}
            </ng-container>
          </td>
          <td class="p-2 align-top font-mono border border-gray-300">{{ rec.type }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="16" class="p-4 text-center text-gray-500">No records found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
